import { configureStore } from "@reduxjs/toolkit"
import authReducer from "@/redux/slices/authSlice"
import orderReducer from "@/redux/slices/orderFormSlice"
import brandReducer from "@/redux/slices/brandSlice"

const store = configureStore({
  reducer: {
    auth: authReducer,
    order: orderReducer,
    brand: brandReducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export default store
